import { useTranslation } from 'react-i18next'
import NavLink from './NavLink'
import { AuthClientTypes } from '../../context/auth/auth.interfaces'
import HamburgerNav from './HamburgerNav'
import { AiOutlineSetting } from 'react-icons/ai'
import { FiHome, FiBarChart, FiUser, FiSlash } from 'react-icons/fi'
import { CgFileDocument } from 'react-icons/cg'
import { BiCategory } from 'react-icons/bi'
import { IoIosGitBranch } from 'react-icons/io'
import IconPlanAndBilling from '../Icons/IconPlanAndBilling'
import IconSupport from '../Icons/IconSupport'
import IconTransactions from '../Icons/IconTransactions'
import IconOrganizations from '../Icons/IconOrganizations'

interface Props {
  role: AuthClientTypes['user_type']
}

const Navigation = ({ role }: Props) => {
  const { t } = useTranslation()

  const roleRoutes =
    role === 'COMPLIANCE_OFFICER' ? (
      <>
        <NavLink path='dashboard' text={t('dashboard')}>
          <FiHome className='text-2xl text-white' />
        </NavLink>
        <NavLink path='reports' text={t('reports')}>
          <CgFileDocument className='text-2xl text-white' />
        </NavLink>
        <NavLink path='statistics' text={t('statistics')}>
          <FiBarChart className='text-2xl text-white' />
        </NavLink>
        <NavLink path='settings' text={t('settings')}>
          <AiOutlineSetting className='text-2xl text-white' />
        </NavLink>
      </>
    ) : role === 'SUPER_ADMINISTRATOR' ? (
      <>
        <NavLink path='organizations' text={t('organizations')}>
          <IconOrganizations />
        </NavLink>
        <NavLink path='transactions' text={t('transactions')}>
          <IconTransactions />
        </NavLink>
        <NavLink path='cancellations' text={t('cancellations')}>
          <FiSlash className='text-2xl text-white' />
        </NavLink>
        <NavLink path='settings' text={t('settings')}>
          <AiOutlineSetting className='text-2xl text-white' />
        </NavLink>
      </>
    ) : role === 'ADMINISTRATOR' ? (
      <>
        <NavLink path='users' text={t('users')}>
          <FiUser className='text-2xl text-white' />
        </NavLink>
        <NavLink path='categories' text={t('categories')}>
          <BiCategory className='text-2xl text-white' />
        </NavLink>
        <NavLink path='branches' text={t('branches')}>
          <IoIosGitBranch className='text-2xl text-white' />
        </NavLink>
        <NavLink path='plan-and-billing' text={t('planAndBilling')}>
          <IconPlanAndBilling />
        </NavLink>
        <NavLink path='settings' text={t('settings')}>
          <AiOutlineSetting className='text-2xl text-white' />
        </NavLink>
      </>
    ) : role === 'HR' ? (
      <>
        <NavLink path='statistics' text={t('statistics')}>
          <FiBarChart className='text-2xl text-white' />
        </NavLink>
        <NavLink path='settings' text={t('settings')}>
          <AiOutlineSetting className='text-2xl text-white' />
        </NavLink>
      </>
    ) : null

  // Support sits pinned to the bottom of the sidebar, away from the main list.
  const supportRoute =
    role === 'ADMINISTRATOR' ? (
      <NavLink path='support' text={t('support')}>
        <IconSupport />
      </NavLink>
    ) : null

  return (
    <>
      <HamburgerNav role={role} />
      <nav className='hidden sm:flex sm:flex-col w-full bg-navBlue items-center xl:px-7 py-32 max-w-[64px] min-w-[64px] xl:max-w-[330px] xl:min-w-[330px] xl:items-start'>
        <ul className='flex flex-col gap-7 w-full'>{roleRoutes}</ul>
        {supportRoute && (
          <ul className='flex flex-col gap-7 w-full mt-auto pt-7'>
            {supportRoute}
          </ul>
        )}
      </nav>
    </>
  )
}

export default Navigation
